/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap Maker (Free, Online) — Toolverse`)
};

const es_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Mapas de Calor (Gratis, Online) — Toolverse`)
};

const de_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmapmaker (gratis, online) — Toolverse`)
};

const fr_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de carte de chaleur (gratuit, en ligne) — Toolverse`)
};

const it_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di mappe di calore (gratuito, online) — Toolverse`)
};

const pt_br2_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Mapa de Calor (Grátis, Online) — Toolverse`)
};

const pt_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Mapas de Calor (Grátis, Online) — Toolverse`)
};

const ja_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒートマップ作成ツール（無料・オンライン） — Toolverse`)
};

const zh_heat_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热力图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_meta_title", locale)
	if (locale === "en") return en_heat_meta_title(inputs)
	if (locale === "es") return es_heat_meta_title(inputs)
	if (locale === "de") return de_heat_meta_title(inputs)
	if (locale === "nl") return nl_heat_meta_title(inputs)
	if (locale === "fr") return fr_heat_meta_title(inputs)
	if (locale === "it") return it_heat_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_heat_meta_title(inputs)
	if (locale === "pt") return pt_heat_meta_title(inputs)
	if (locale === "ja") return ja_heat_meta_title(inputs)
	return zh_heat_meta_title(inputs)
};